import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Button, Form, FormFeedback, FormGroup, Input, InputGroupAddon } from 'reactstrap';
import { Link } from 'react-router-dom';
class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onUsernameChange = this.onUsernameChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onSendSms = this.sendSms.bind(this);
    this.timer = '20';
    this.userData = JSON.parse(localStorage.getItem('2fa-auth'));
    this.state = {
      showPass: false,
      seconds: this.timer,
      disableSendSms: false,
      disableSendEmail: false,
      disableViseVersa: false,
      disable2FaOtp: false,
      authMode: 'sms',
    };
  }

  onFormSubmit(ev) {
    ev.preventDefault();
    const { authMode } = this.state;
    const { username, password, onLogin, type } = this.props;
    onLogin(username, password, type, authMode);
  }

  onUsernameChange(ev) {
    const email = ev.target.value;
    this.props.onLoginDataChange(email, this.props.password);
  }

  onPasswordChange(ev) {
    ev.preventDefault();
    const password = ev.target.value;
    this.props.onLoginDataChange(this.props.username, password);
  }

  sendSms() {
    this.props.onSendOtp();
    this.setState({ disableSendSms: true, disableViseVersa: true, authMode: 'sms' });
    this.myInterval = setInterval(() => {
      this.setState(
        ({ seconds }) => ({
          seconds: seconds - 1,
        }),
        () => {
          if (this.state.seconds === 0) {
            this.setState({
              disableSendSms: false, seconds: this.timer, disableViseVersa: false,
              disable2FaOtp: false,
            });
            clearInterval(this.myInterval);
          }
        },
      );
    }, 1000);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.otpStatus !== this.props.otpStatus) {
      this.setState({
        disableSendEmail: false,
        disableSendSms: false,
        seconds: this.timer,
        disableViseVersa: false,
      });
      clearInterval(this.myInterval);
    }
  }

  componentDidMount() {
    this.on2FaApp()
  }
  sendEmail = () => {
    this.props.onSendEmailOtp();
    this.setState({ disableSendEmail: true, disableViseVersa: true, authMode: 'email' });
    this.myInterval = setInterval(() => {
      this.setState(
        ({ seconds }) => ({
          seconds: seconds - 1,
        }),
        () => {
          if (this.state.seconds === 0) {
            this.setState({
              disableSendEmail: false,
              seconds: this.timer,
              disableViseVersa: false,
              disable2FaOtp: false,
            });
            clearInterval(this.myInterval);
          }
        },
      );
    }, 1000);
  };

  on2FaApp = () => this.setState({ disableViseVersa: false, disable2FaOtp: true, authMode: '2factorapp' });

  render() {
    const { type, password, username } = this.props;
    const { disableSendEmail, seconds, showPass, disableSendSms, disableViseVersa, disable2FaOtp } = this.state;
    return (
      <Form onSubmit={this.onFormSubmit} style={{ position: 'relative' }}>
        <FormGroup>
          <Input
            className="input-field"
            type="email"
            id="email"
            name="email"
            disabled={type === '2fa'}
            onChange={this.onUsernameChange}
            value={type === '2fa' ? this.userData.email : username}
            placeholder="Email"
            required
          />
          {/* {type !== '2fa' ? <FormFeedback>* This field is required</FormFeedback> : null} */}
        </FormGroup>
        <FormGroup>
          <Input
            className="input-field"
            id={(type === '2fa') ? '2fa' : 'password'}
            type={(showPass || type === '2fa') ? 'text' : 'password'}
            name="password"
            onChange={this.onPasswordChange}
            placeholder={type === '2fa' ? 'Verification Token' : 'Password'}
            required
            autocomplete="off"
            style={{ borderRight: '0px !important' }}
            autoFocus={type === '2fa'}
          />
          {type !== '2fa' && <InputGroupAddon
            addonType="append"
            className="show-password"
            onClick={() => this.setState({ showPass: !showPass })}
          >

            <FontAwesomeIcon icon={!showPass ? 'eye-slash' : 'eye'} size="lg" color="#8998ac" />
          </InputGroupAddon>}
          {/* <FormFeedback>* This field is required</FormFeedback> */}
        </FormGroup>

        <FormGroup className="d-flex justify-content-between">
          {type === '2fa' && (
            <Button
              disabled={disable2FaOtp || disableViseVersa}
              color="primary"
              className="otp-buttons"
              onClick={this.on2FaApp}
            >
              Use 2FA App
            </Button>
          )}
          {type === '2fa' && this.userData.phoneNumber && (
            <Button
              disabled={disableSendSms || disableViseVersa}
              color="primary"
              className="otp-buttons"
              onClick={this.onSendSms}
            >
              {disableSendSms ? `Didn't get the code? Resend after ${seconds} sec` : 'Send via SMS'}
            </Button>
          )}
          {type === '2fa' && (
            <Button
              disabled={disableSendEmail || disableViseVersa}
              color="primary"
              className="otp-buttons"
              onClick={this.sendEmail}
            >
              {disableSendEmail
                ? `Didn't get the code? Resend after ${seconds} sec`
                : 'Send via Email'}
            </Button>
          )}

          <Button color="primary" type="submit" className="otp-buttons">
            {type === '2fa' ? 'Verify' : 'Login'}
          </Button>
          <Link className="reset-password-forgot" to="/reset-password">
            Password Reset
          </Link>
        </FormGroup>
        {type === '2fa' && this.userData.phoneNumber && (
          <p style={{ color: '#8998ac' }}>SMS verification number is {this.userData.phoneNumber}</p>
        )}
      </Form>
    );
  }
}

export default LoginForm;
